import { render, staticRenderFns } from "./ResultsPageContent.vue?vue&type=template&id=7215e5ea&scoped=true"
import script from "./ResultsPageContent.vue?vue&type=script&lang=ts"
export * from "./ResultsPageContent.vue?vue&type=script&lang=ts"
import style0 from "./ResultsPageContent.vue?vue&type=style&index=0&id=7215e5ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7215e5ea",
  null
  
)

export default component.exports